import React from "react";
import { Box, Button } from "@mui/material";

const PromptList = ({ prompts = [], onSelectPrompt }) => {
    return (
        <Box className="prompt-list">
            <Box className="prompt-buttons">
                {prompts.map((prompt, index) => (
                    <Button
                        key={index}
                        variant="outlined"
                        fullWidth
                        size="small"
                        onClick={() => onSelectPrompt(prompt)}
                        style={{
                            marginBottom: "8px",
                            textTransform: "none",
                            justifyContent: "flex-start",
                        }}
                    >
                        {prompt}
                    </Button>
                ))}
            </Box>
        </Box>
    );
};

export default PromptList;